import { Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import type { BookingScheduleInterface } from "../../../features/Booking-Form/typings/booking.types";
import { ScheduleEventBookingSubject } from "../schedule-event-popover-booking-subject";

type P = {
  schedule: BookingScheduleInterface;
  subject: string;
  isSubjectEditable: boolean;
  onSubjectEdit: (value: string) => Promise<void>;
  currentRoomLabel: string;
  newRoomLabel?: string;
};

export function ChangeConferenceRoomReadOnlySummary({
  schedule,
  subject,
  isSubjectEditable,
  onSubjectEdit,
  currentRoomLabel,
  newRoomLabel
}: Readonly<P>) {
  const { t } = useTranslation();
  const newRoomDisplay = newRoomLabel ?? t("_changeRoom_newRoomPending");

  return (
    <Stack spacing={1} data-testid="change-conference-room-summary">
      <Stack spacing={0.25}>
        <Typography variant="caption" color="text.secondary">
          {t("_changeRoom_subjectLabel")}
        </Typography>
        <ScheduleEventBookingSubject
          subject={subject}
          schedule={schedule}
          isEditable={isSubjectEditable}
          onEditSubject={onSubjectEdit}
        />
      </Stack>

      <Stack
        direction="row"
        spacing={2}
        alignItems="flex-end"
        sx={{ width: "fit-content", maxWidth: "100%" }}
        data-testid="change-room-summary-rooms"
      >
        <Stack spacing={0.25}>
          <Typography variant="caption" color="text.secondary">
            {t("_changeRoom_currentRoom")}
          </Typography>
          <Typography variant="body2" data-testid="change-room-current-room">
            {currentRoomLabel}
          </Typography>
        </Stack>

        <Box
          sx={{ pb: 0.5, px: 0.5, fontSize: "1.25rem", fontWeight: 500, lineHeight: 1 }}
          aria-hidden
        >
          →
        </Box>
        <Stack spacing={0.25}>
          <Typography variant="caption" color="text.secondary">
            {t("_changeRoom_newRoom")}
          </Typography>
          <Typography
            variant="body2"
            fontWeight={newRoomLabel ? 600 : undefined}
            color={newRoomLabel ? "text.primary" : "text.secondary"}
            data-testid="change-room-new-room"
          >
            {newRoomDisplay}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
}
